export const SUCCESS = 'success'
export const ERROR = 'error'

export const DEVELOPMENT = process.env.NODE_ENV === 'development'

export const SAILOR_TYPE = "sailor";
export const JUDGE_TYPE = "judge";

export const INIT_REGATTA_STATE = "notStarted";
export const IN_PROGRESS_REGATTA_STATE = "inProgress";
export const FINALIZED_REGATTA_STATE = "finalized";